import { c as _c } from "react/compiler-runtime";
import { ICON_LARGE_STYLE, SphereAvatar } from "@components/header/sphere-avatar";
import { UpdateProfilePictureDialog } from "@components/user-info/update-profile-picture-dialog";
import { Box } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";
import { grey, TeamIcon, CameraIcon } from "@flat-ui";
import { getPendingUserIcon, getUserInitials } from "@utils/user-utils";
import { useState } from "react";
import { teamDisplayProperties } from "@components/table/teams/teams-table-utils";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Renders SphereAvatar component with ability to update avatar */
export function SphereUpdatableAvatar(t0) {
  const $ = _c(25);
  const {
    member,
    team
  } = t0;
  const loggedInUser = useAppSelector(loggedInUserSelector);
  const [isAvatarHovering, setIsAvatarHovering] = useState(false);
  const [isProfilePictureDialogOpen, setIsProfilePictureDialogOpen] = useState(false);
  const isCurrentUser = member.identity === loggedInUser?.identity;
  if (FaroCoreApiUtils.Member.isTeam(member)) {
    const teamCategory = team?.category?.kind ?? "default";
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <TeamIcon style={ICON_LARGE_STYLE} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    const t2 = teamDisplayProperties[teamCategory];
    let t3;
    if ($[1] !== t2.color) {
      t3 = <SphereAvatar size="x-large" icon={t1} backgroundColor={t2.color} />;
      $[1] = t2.color;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  if (!isCurrentUser) {
    let t1;
    if ($[3] !== member) {
      t1 = getUserInitials(member);
      $[3] = member;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== member) {
      t2 = getPendingUserIcon(member, "large");
      $[5] = member;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== member.thumbnailUrl || $[8] !== t1 || $[9] !== t2) {
      t3 = <SphereAvatar size="x-large" initials={t1} icon={t2} src={member.thumbnailUrl} />;
      $[7] = member.thumbnailUrl;
      $[8] = t1;
      $[9] = t2;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    return t3;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsAvatarHovering(true);
    t2 = () => setIsAvatarHovering(false);
    t3 = () => setIsProfilePictureDialogOpen(true);
    t4 = {
      width: "fit-content",
      cursor: "pointer"
    };
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isAvatarHovering || $[16] !== isCurrentUser || $[17] !== loggedInUser) {
    t5 = <Box component="div" onMouseEnter={t1} onMouseLeave={t2} onClick={t3} sx={t4}>{isAvatarHovering ? <SphereAvatar size="x-large" icon={<CameraIcon sx={{
        ...ICON_LARGE_STYLE
      }} />} iconColor={PALETTE_VARS.primary.main} shouldUseSimplifiedAvatar={!isCurrentUser} backgroundColor={PALETTE_VARS.surface.strong} /> : <SphereAvatar size="x-large" initials={getUserInitials(loggedInUser)} iconColor={PALETTE_VARS.primary.main} src={loggedInUser.thumbnailUrl} shouldUseSimplifiedAvatar={!isCurrentUser} backgroundColor={grey[400]} />}</Box>;
    $[15] = isAvatarHovering;
    $[16] = isCurrentUser;
    $[17] = loggedInUser;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== isProfilePictureDialogOpen || $[20] !== loggedInUser) {
    t6 = isProfilePictureDialogOpen && <UpdateProfilePictureDialog user={loggedInUser} isDialogOpen={isProfilePictureDialogOpen} setIsDialogOpen={setIsProfilePictureDialogOpen} />;
    $[19] = isProfilePictureDialogOpen;
    $[20] = loggedInUser;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t5 || $[23] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}